export const CHECK_VALUES_ERROR_MESSAGE = 'Проверьте корректность введенных данных'

export const USER_NOT_FOUND = 'Неверные E-mail или пароль'

export const VALIDATION_ERR_MESSAGE = `Ошибка валидации данных. ${CHECK_VALUES_ERROR_MESSAGE}`

export const AUTH_ERROR_MESSAGES_BY_CODE = {
  422: CHECK_VALUES_ERROR_MESSAGE,
  404: `${USER_NOT_FOUND}. ${CHECK_VALUES_ERROR_MESSAGE}`,
}
